import React from 'react'
import Logo from '../Assets/Images/Loading/Logo.png'
import '../Style/Loading.scss'
import { useEffect } from 'react'
import { preLoaderAnim } from './Animation'
function Loading() {
    useEffect(() =>{
        preLoaderAnim()
    })
  return (
    <div className='preloader'>
        <span>
          <img className='image' src={'https://res.cloudinary.com/doy2qixs5/image/upload/v1745494421/rbn/projects/logo/favicon.png'} />
        </span>
    </div>
  )
}

export default Loading